module.exports = __webpack_public_path__ + "static/media/Social Marketplace App Over view - GBR Tech - 03-10-2024 C.d713cb34.gif";